import React, { useState } from "react";
import "./beauty.css";
import belly from "../../assets/belly.png";
import { Link } from "react-router-dom";

const Travel = ({selectedTool, setSelectedTool}) => {
  const [activeTab, setActiveTab] = useState("Do's");
  const [expandedItem, setExpandedItem] = useState(null);

  const data = [
    {
      id: 1,
      name: "Bikini Wax",
      category: "Do's",
      description: {
        part1:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been thedustry's standard dummy text ever since the 1500s.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularized in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages.",
        part2:
          "It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularized in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been thedustry's standard dummy text ever since the 1500s.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularized in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages.",
      },
      image: belly,
    },
    {
      id: 2,
      name: "Shape wear",
      category: "Warning",
      description: {
        part1:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been thedustry's standard dummy text ever since the 1500s.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularized in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages.",
        part2:
          "It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularized in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been thedustry's standard dummy text ever since the 1500s.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularized in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages.",
      },
      image: belly,
    },
    {
      id: 3,
      name: "Yoga Mat",
      category: "Dont's",
      description: {
        part1:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been thedustry's standard dummy text ever since the 1500s.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularized in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages.",
        part2:
          "It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularized in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been thedustry's standard dummy text ever since the 1500s.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularized in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages.",
      },
      image: belly,
    },

    {
      id: 4,
      name: "Yoga Mat",
      category: "Warning",
      description: {
        part1:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been thedustry's standard dummy text ever since the 1500s.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularized in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages.",
        part2:
          "It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularized in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been thedustry's standard dummy text ever since the 1500s.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularized in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages.",
      },
      image: belly,
    },
    {
      id: 5,
      name: "Head Wax",
      category: "Do's",
      description: {
        part1:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been thedustry's standard dummy text ever since the 1500s.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularized in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages.",
        part2:
          "It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularized in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been thedustry's standard dummy text ever since the 1500s.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularized in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages.",
      },
      image: belly,
    },
    {
      id: 6,
      name: "Body Art",
      category: "Do's",
      description: {
        part1:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been thedustry's standard dummy text ever since the 1500s.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularized in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages.",
        part2:
          "It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularized in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been thedustry's standard dummy text ever since the 1500s.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularized in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages.",
      },
      image: belly,
    },
  ];

  const handleTabClick = (tab) => setActiveTab(tab);

  const toggleItem = (id) => setExpandedItem(expandedItem === id ? null : id);

  const filteredItems = data.filter((item) => item.category === activeTab);

  // Dynamic background class
  const getBackgroundClass = () => {
    switch (activeTab) {
      case "Do's":
        return "safe-bg";
      case "Warning":
        return "warning-bg";
      case "Dont's":
        return "danger-bg";
      default:
        return "";
    }
  };

  return (
    <div className="beauty-base">
      <div className="beauty-cont">
        <div className="bread-container">
          <nav aria-label="breadcrumb">
            <ol className="crumb">
              <li className="breadcrumblist">
                <Link to="/" className="breadcrumb-link" onClick={()=>setSelectedTool("")}>
                  Home
                </Link>
              </li>
              <li className="breadcrumblist">
                <Link to="/dos-donts" className="breadcrumb-link">
                  Dos...
                </Link>
              </li>
              <li className="breadcrumblist active">Travel</li>
            </ol>
          </nav>
        </div>
        <div className={`beauty-style-container ${getBackgroundClass()}`}>
          <h2>Travel</h2>
          <div className="tabs">
            {["Do's", "Warning", "Dont's"].map((tab) => (
              <button
                key={tab}
                className={`tab-button ${activeTab === tab ? "active" : ""}`}
                onClick={() => handleTabClick(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
          <div className="item-list">
            {filteredItems.map((item) => (
              <div
                key={item.id}
                className={`item ${expandedItem === item.id ? "expanded" : ""}`}
                onClick={() => toggleItem(item.id)}
              >
                <div className="item-header">
                  <span style={{ color: "black" }}>{item.name}</span>
                  <span className="toggle-icon">
                    {expandedItem === item.id ? "▲" : "▼"}
                  </span>
                </div>
                <div
                  className={`item-details ${
                    expandedItem === item.id ? "show" : ""
                  }`}
                >
                  {expandedItem === item.id && (
                    <div className="toggle-lists">
                      <h4 style={{ textAlign: "center" }}>{item.name}</h4>
                      <img
                        src={item.image}
                        alt={item.name}
                        className="item-image"
                      />
                      <p style={{ textAlign: "justify" }}>
                        {item.description.part1}
                      </p>
                      <p style={{ textAlign: "justify" }}>
                        {item.description.part2}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Travel;
